import { render } from "./screenshots.vue?vue&type=template&id=1128bcf2&scoped=true"
import script from "./screenshots.vue?vue&type=script&lang=js"
export * from "./screenshots.vue?vue&type=script&lang=js"

import "./screenshots.vue?vue&type=style&index=0&id=1128bcf2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1128bcf2"]])

export default __exports__